import { capitalCase } from 'change-case';
import { Link as RouterLink } from 'react-router-dom';
import { useState } from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Card, Stack, Link, Alert, Tooltip, Container, Typography } from '@mui/material';
// routes
import { PATH_AUTH } from '../../../routes/paths';
// hooks
import useAuth from '../../../hooks/useAuth';
import useResponsive from '../../../hooks/useResponsive';
// components
import Page from '../../../components/Page';
import Logo from '../../../components/Logo';
import Image from '../../../components/Image';
// sections
import { LoginForm } from '../../../sections/public/auth/login';
import VerifyCode from './VerifyCode';
import VerifyCodeForm from '../../../sections/public/auth/verify-code/VerifyCodeForm';
import maskPhoneNumber from '../../../utils/maskPhoneNumber';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  zIndex: 9,
  lineHeight: 0,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  padding: theme.spacing(3),
  justifyContent: 'space-between',
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-start',
    padding: theme.spacing(7, 5, 0, 7),
  },
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2),
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function Login({
                                whitoutSideImage = false
                              }) {
  const [stateVerify,setStateVerify]=useState();
  const [LoginError, setLoginError] = useState("")
  const { method } = useAuth();

  const smUp = useResponsive('up', 'sm');

  const mdUp = useResponsive('up', 'md');

  const goToVerify=(data)=>{
    setStateVerify(data)
  }
  const goToLogin=({
    hasError = false , 
    error= ""
  })=>{
    if(hasError){
      setLoginError(error)
    }else{
      setLoginError("")
    }
    setStateVerify(false)
  }
  

  return (
    <Page title="Login">
      <RootStyle>
        <HeaderStyle>
          {/* <Logo /> */}
          {/* {smUp && (
            <Typography variant="body2" sx={{ mt: { md: -2 } }}>
              Don’t have an account? {''}
              <Link variant="subtitle2" component={RouterLink} to={PATH_AUTH.register}>
                Get started
              </Link>
            </Typography>
          )} */}
        </HeaderStyle>

        {(mdUp && !whitoutSideImage) && (
          <SectionStyle
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {/* <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
              {'خوش آمدید'}
            </Typography> */}
            {/* <Image visibleByDefault disabledEffect alt="login" src="/images/illustration_login.png" /> */}
            <Link href='/'>
            <Image
              sx={{
                width: '250px',
              }}
              visibleByDefault
              disabledEffect
              alt="login"
              // src="https://cdn.labbayk.ir/assetss/img/setadlogo.png"
              src="/icons/logo.svg"
            />
            </Link>

          </SectionStyle>
        )}

        <Container maxWidth="sm">
          <ContentStyle>
            <Stack direction="row" alignItems="center" sx={{ mb: 5 }}>
             {stateVerify? <Box sx={{ flexGrow: 1 }}>
                <Typography variant="h4" gutterBottom>
                  {`تایید ورود`}
                </Typography>
                <Typography sx={{ color: 'text.secondary' }}>{`رمز عبور برای شما به شماره موبایل ${maskPhoneNumber(stateVerify?.phone)} ارسال شد.`}</Typography>
              </Box>:
               <Box sx={{ flexGrow: 1 }}>
               <Typography variant="h4" gutterBottom>
                 {`خوش آمدید`}
               </Typography>
               <Typography sx={{ color: 'text.secondary' }}>{'اطلاعات خود را وارد کنید'}</Typography>
             </Box>
              }

              {/* <Tooltip title={capitalCase(method)} placement="right">
                <>
                  <Image
                    disabledEffect
                    src={`https://minimal-assets-api.vercel.app/assets/icons/auth/ic_${method}.png`}
                    sx={{ width: 32, height: 32 }}
                  />
                </>
              </Tooltip> */}
            </Stack>

            {/* <Alert severity="info" sx={{ mb: 3 }}>
              Use email : <strong>admin@gmail.com</strong> / password :<strong> admin</strong>
            </Alert> */}

           {stateVerify?<VerifyCodeForm goToLogin={goToLogin}goToVerify={goToVerify} {...stateVerify} />:<LoginForm goToVerify={goToVerify} LoginError={LoginError} />}

            {/* {!smUp && (
              <Typography variant="body2" align="center" sx={{ mt: 3 }}>
                Don’t have an account?{' '}
                <Link variant="subtitle2" component={RouterLink} to={PATH_AUTH.register}>
                  Get started
                </Link>
              </Typography>
            )} */}
          </ContentStyle>
        </Container>
      </RootStyle>
    </Page>
  );
}
